import React from 'react';
import { HeroSection } from '../components/landing/HeroSection';
import { ProblemSection } from '../components/landing/ProblemSection';
import { SolutionSection } from '../components/landing/SolutionSection';
import { AudienceSection } from '../components/landing/AudienceSection';
import { TimelineSection } from '../components/landing/TimelineSection';
import { FAQSection } from '../components/landing/FAQSection';
import { OfferSection } from '../components/landing/OfferSection';
import { Footer } from '../components/landing/Footer';
export function LandingPage() {
  return <main className="min-h-screen bg-[#FAFAFA] font-sans selection:bg-[#0D6E6E] selection:text-white" data-id="element-217">
      <HeroSection data-id="element-218" />
      <ProblemSection data-id="element-219" />
      <SolutionSection data-id="element-220" />
      <AudienceSection data-id="element-221" />
      <TimelineSection data-id="element-222" />
      <FAQSection data-id="element-223" />
      <OfferSection data-id="element-224" />
      <Footer data-id="element-225" />
    </main>;
}